import LoginSdk from './login-sdk.vue';
import type { InterfaceGlobalLogin } from './typings';

const install = (Vue: any) => {
  Vue.component('login-sdk', LoginSdk);
};

/* istanbul ignore if */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { LoginSdk };

export const globalLogin: InterfaceGlobalLogin = {
  version: '0.0.1',
  install,
  LoginSdk,
};

export default globalLogin;
